import { render, staticRenderFns } from "./DeleteCif.vue?vue&type=template&id=6948cbc7&scoped=true"
import script from "./DeleteCif.vue?vue&type=script&lang=js"
export * from "./DeleteCif.vue?vue&type=script&lang=js"
import style0 from "./DeleteCif.vue?vue&type=style&index=0&id=6948cbc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948cbc7",
  null
  
)

export default component.exports